import { useEffect } from 'react';
import type { CustomEventMap } from '../dom';
import type { FetchError } from '../utils/http.types';

export const CustomEventType = {
  HTTP_UNAUTHORIZED: 'httpunauthorized',
  MFA_REQUIRED: '2farequired',
  MFA_REQUIRED_CONSUMED: 'mfarequiredconsumed',
  MFA_RESULT: 'mfaresult',
} as const;
export type CustomEventType = (typeof CustomEventType)[keyof typeof CustomEventType];
// mfa
export type UnauthorizedEventDetail = { error: FetchError };
export type MFAResultEventDetails = { result: 'success' | 'failure' | 'dismissed' };

export const useDocumentCustomEventListener = function <T extends keyof CustomEventMap>({
  eventType,
  handler,
}: {
  eventType: T;
  handler: (e: CustomEventMap[T]) => void;
}) {
  useEffect(() => {
    const internalHandler: EventListener = (e: CustomEventMap[T] | Event) => {
      handler(e as CustomEventMap[T]);
    };
    document.addEventListener(eventType, internalHandler);
    return () => {
      document.removeEventListener(eventType, internalHandler);
    };
  }, [eventType, handler]);
};
